import * as React from "react"
const IconPOS = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 20}
        height={props.height ?? 15}
        viewBox="0 0 20 15"
        fill="none"
        {...props}
    >
        <path
            stroke={props.stroke ?? "#94A3B8"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={props.strokeWidth ?? 2}
            d="M1 14h18M3 2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2Z"
        />
    </svg>
)
export default IconPOS
